function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "Rectangle_76566",
  "data-name": "Rectangle 76566",
  width: 15.798,
  height: 15.798,
  transform: "translate(0 0)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_16841",
  "data-name": "Group 16841",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_22383",
  "data-name": "Path 22383",
  d: "M14.324,6.425H9.374V1.475a1.474,1.474,0,1,0-2.949,0v4.95H1.474a1.474,1.474,0,0,0,0,2.949H6.425v4.949a1.474,1.474,0,1,0,2.949,0V9.374h4.95a1.474,1.474,0,0,0,0-2.949"
}));

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_18215",
    "data-name": "Group 18215",
    width: 15.798,
    height: 15.798,
    viewBox: "0 0 15.798 15.798",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Plus.b7f57571.svg";
export { ForwardRef as ReactComponent };